// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31aMk","label":"styles_label__39Avx"};